import { render, staticRenderFns } from "./AddFundings.vue?vue&type=template&id=1528d224&"
import script from "./AddFundings.vue?vue&type=script&lang=js&"
export * from "./AddFundings.vue?vue&type=script&lang=js&"
import style0 from "./AddFundings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports